import { Routing } from "pages";
import { withProviders } from "./providers";
import './index.scss';

import 'moment/locale/ru';

const App = () => {
  return ( 
    <Routing />
  );
}

export default withProviders(App);
